import Vue from 'vue';

const cloudName = process.env.VUE_APP_CLOUDINARY_CLOUDNAME;
const uploadPreset = process.env.VUE_APP_CLOUDINARY_UPLOAD_PRESET;
const url = `https://api.cloudinary.com/v1_1/${cloudName}/image/upload`;

let amountOfImagesBeingSaved = 0;

function startSaveImage() {
  amountOfImagesBeingSaved += 1;
  window.onbeforeunload = () => 'We are saving an image, closing the browser now will discard it.';
}

function stopSaveImage() {
  amountOfImagesBeingSaved -= 1;
  if (amountOfImagesBeingSaved === 0) {
    window.onbeforeunload = null;
  }
}

// Returns cloudinary secure url: str
// (which can be used to create CloudinaryField instance in backend)
async function upload(file) {
  if (!file) { throw Error("No file was supplied to 'upload()'"); }

  const formData = new FormData();
  formData.append('file', file);
  formData.append('upload_preset', uploadPreset);

  const options = {
    body: formData,
    method: 'post',
    credentials: 'omit',
  };

  startSaveImage();
  return new Promise((resolve, reject) => {
    fetch(url, options)
      .then(response => response.json())
      .then((json) => {
        stopSaveImage();
        return resolve(json.secure_url);
      })
      .catch((error) => {
        stopSaveImage();
        reject(error);
      });
  });
}

Vue.prototype.$upload = upload;
